import {
  GET_SITE_FEATURES_REQUEST,
  GET_SITE_FEATURES_SUCCESS,
  GET_SITE_FEATURES_FAILURE,
  CLEAR_FEATURES,
} from "actions/feature";

const initialState = {
  loading: false,
  error: {},
  features: {},
};

export default function feature(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SITE_FEATURES_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SITE_FEATURES_SUCCESS: {
      return {
        ...state,
        loading: false,
        features: payload || {},
        error: {},
      };
    }

    case GET_SITE_FEATURES_FAILURE: {
      // Fail open: keep features empty so nothing is hidden on error.
      return {
        ...state,
        loading: false,
        features: {},
        error: payload,
      };
    }

    case CLEAR_FEATURES: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
}
